export enum ApplicationSettings {
    EffectivenessTestingReviewerRequired = 1,
    UseSimpleEffectiveness = 4,
    ShowCauseField = 6,
    ShowEffectField = 7,
    ShowQuantitativeScoringDetails = 8,
    UseRaciTable = 9,
    CustomerLogo = 12,
    AccentColor = 13,
    GenerateSamplesType = 41,
    ShowDashboardType = 51,
    UseControlAnalysis = 61,
    EnableTargetRisk = 760,
    EnableBudgetBasedRisk = 770,
    FeatureToggleCreai = 790,
    EnableAiAssistance = 989,
    EnableAiEvidenceReviewer = 990,
    UseIncidents = 11000,
    HideIncidentMoiOption = 11001,
    ActionsGenerateScimToken = 20001
}